import { Field, Form, Formik } from "formik";
import { FC } from "react";
import Modal from 'react-modal';
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import closeIcon from '@/images/close.svg';
import Label from "@/components/label/label";
import DateField from "@/components/date-field/date-field";
import { MasterExpiry } from "@/models/MasterExpiry";
import { requiredValidation } from "@/utilities/Validation";
import { ASSIGNING_TYPE } from "@/constants/expiry-reason-constant";

interface MasterExpiryModalProps {
    isOpen: boolean;
    onClose: () => void;
    masterExpiry: MasterExpiry | undefined;
    onSave: (values: any) => Promise<void>;
    assigningType: ASSIGNING_TYPE
}

const EditMasterExpiryModal: FC<MasterExpiryModalProps> = ({ isOpen, onClose, masterExpiry, onSave, assigningType }) => {
    const { translate } = useLocale();
    const initialValues = {
        ...masterExpiry,
        meStartDateTime: masterExpiry?.meStartDateTime ? new Date(masterExpiry.meStartDateTime) : undefined
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden">
        <Formik
            key={String(isOpen)}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSave}>
            {({ errors, isValid }) => (
                <Form>
                    <div style={{ width: '270px' }}>
                        <div className="w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between">
                            <span className="font-bold text-white">{assigningType === "EXPIRY_REASONS" ? masterExpiry?.expiryReason.name : masterExpiry?.master.name }</span>
                            <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" alt="close" />
                        </div>
                        <div className="flex flex-col p-2" data-cy="startDatePicker">
                            <div className="flex flex-row justify-between">
                                <Label htmlFor="meStartDateTime" className="text-xs text-gray-600 mt-1" required>
                                    {translate.byKey(TranslationKeys.startDate)}:
                                </Label>
                                {errors.meStartDateTime ? <span className="text-red-600 text-xs">{errors.meStartDateTime as string}</span> : null}
                            </div>
                            <Field name="meStartDateTime" component={DateField} valueName="meStartDateTime" useOnMouseDown validate={requiredValidation} />
                        </div>
                    </div>
                    <div className="flex flex-row pb-3 justify-end bg-white">
                        <div className="flex flex-row mt-4 pr-2 space-x-2">
                            <button type="button" onClick={onClose} className="secondary secondary-inverse py-1 px-5">
                                {translate.byKey(TranslationKeys.cancel)}
                            </button>
                            <button
                                id="saveMasterExpiryButtonId"
                                className={`secondary py-1 px-5 ${isValid ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                                disabled={!isValid}
                                type="submit">
                                {translate.byKey(TranslationKeys.save)}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    </Modal>
};

export default EditMasterExpiryModal;